// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___56576860f28ca200fa3","cls2":"Header-cls2__fb5a987f116cc5090836 Header-cls1___56576860f28ca200fa3"};